import React from 'react';
type PageContainerProps = {
  children: React.ReactNode;
};
export const PageContainer: React.FC<PageContainerProps> = ({
  children
}) => {
  return <main className="pb-20 pt-3 px-3 sm:pt-4 sm:px-4 md:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-308">
      {children}
    </main>;
};